import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import listContext from '../../../Common/context/context'

import {
    totalDataCountExt, divideNumbers, getFormattedNumber, isUndefinedOrNull, getAnnualEffectiveRent,
    isStudentHousingProperty, isHealthCareProperty, sortUnitMixData
} from '../../Utility/PropertyListUtility'

const useStyles = makeStyles({
    table: {
        maxWidth: '100%',
    },
    tableCell: {
        width: '8% !important'
    }
})

const UnitMixTable = props => {
    const classes = useStyles()

    let { data, columns, property, source } = props
    const [unitMixData, setUnitMixData] = useState([])
    const [isOnLoad, setIsOnLoad] = useState(true)
    const [sort, setSort] = useState({ field: 'unitType', order: 'asc' })
    const { propertyList, setPropertyList } = useContext(listContext)

    useEffect(() => {
        if (data) {
            // setIsOnLoad is set to true coz if source changes, data changes
            setIsOnLoad(true)
            // data.forEach(item => {
            //     if (item['unitType'] === 'Studio') {
            //         item['unitType'] = '0 Bedroom/1 Bath'
            //     }
            //     item['unitType'] = item['unitType'].replace('Bedroom', 'Bed')
            // })
            const rowIndex = propertyList.compsList.findIndex(x => x.omniViewPropertyId === property.omniViewPropertyId)
            const sortBy = propertyList.compsList[rowIndex].sortBy
            const order = propertyList.compsList[rowIndex].sortOrder

            if (sortBy) {
                setSort({ field: sortBy, order })
                data = sortFieldsByName(data, sortBy, order)
            } else {
                data = data.sort((a, b) => a.unitType.localeCompare(b.unitType) || a.units - b.units)
            }
            // data = data.sort((a, b) => a.numberBedrooms - b.numberBedrooms || a.numberBathrooms - b.numberBathrooms || a.units - b.units)

            setUnitMixData(data)

        }
    }, [data])

    useEffect(() => {
        if (unitMixData.length && isOnLoad) {
            setIsOnLoad(false)
            calculateColumnValues()
        }
    }, [source])

    useEffect(() => {
        // setSort({ field: 'unitType', order: 'asc' })
        if (unitMixData.length && isOnLoad) {
            setIsOnLoad(false)
            calculateColumnValues()
        }
    }, [unitMixData])

    const calculateColumnValues = () => {

        let totalUnits = totalDataCountExt('units', unitMixData, unitMixData[0].source, false)

        let newUnitMixData = [...unitMixData]

        for (let i = 0; i < newUnitMixData.length; i++) {
            try {
                newUnitMixData[i].unitPercentage = divideNumbers(newUnitMixData[i].units, totalUnits) * 100
                newUnitMixData[i].highLow = valueFormatter(newUnitMixData[i].minRent, 'currency') + ' - ' + valueFormatter(newUnitMixData[i].maxRent, 'currency')
                // if (newUnitMixData[i].ER_Bed) {
                //     newUnitMixData[i].ER_Bed = Math.round(newUnitMixData[i].ER_Bed)
                // }

                newUnitMixData[i].annualEffectiveRent = getAnnualEffectiveRent(newUnitMixData[i])

                if (isStudentHousingProperty(property) || isHealthCareProperty(property)) {
                    newUnitMixData[i].bedsPerUnit = divideNumbers(newUnitMixData[i].beds, newUnitMixData[i].units)
                    newUnitMixData[i].erBed = divideNumbers(newUnitMixData[i].totalEffectiveRent, newUnitMixData[i].beds)
                    newUnitMixData[i].erBed = newUnitMixData[i].erBed.toFixed(0)
                }

            } catch (error) {
                console.log("error in calculateColumnValues ::: " + error.message)
            }

        }

        setUnitMixData(newUnitMixData)

    }

    const getFieldValue = (fieldRow, fieldCol) => {

        let returnVal = '-'

        try {

            returnVal = isUndefinedOrNull(fieldRow[fieldCol.fieldName])
            returnVal = valueFormatter(returnVal, fieldCol.type)

        } catch (error) {
            console.log("error in getFieldValue ::: " + error.message)
        }

        return returnVal

    }

    const getSummaryValue = fieldCol => {

        let returnVal = '-'

        try {

            returnVal = isUndefinedOrNull(property[fieldCol.sumfieldName])
            returnVal = valueFormatter(returnVal, fieldCol.type)

        } catch (error) {
            console.log("error in getSummaryValue ::: " + error.message)
        }

        return returnVal

    }

    const valueFormatter = (inputVal, type = 'text') => {

        let returnVal = inputVal || ''

        try {
            returnVal = returnVal.toString()

            switch (type) {
                case 'number':
                    returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '', '2', '2') : getFormattedNumber(returnVal)
                    break
                case 'percent':
                    returnVal = getFormattedNumber(returnVal, '%')
                    break
                case 'currency':
                    returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '$', '2', '2') : getFormattedNumber(returnVal, '$')
                    break
                default: break
            }

            returnVal = !returnVal ? '-' : returnVal

        } catch (error) {
            console.log("error in valueFormatter ::: " + error.message)
        }

        return returnVal

    }

    const sortFieldsByName = (unitMixData, sortFieldName, order) => {
        let result = sortUnitMixData(unitMixData, sortFieldName, order)

        updateSortPreference(sortFieldName, order)

        return result
    }

    const updateSortPreference = (sortFieldName, order) => {

        try {
            const rowIndex = propertyList.compsList.findIndex(x => x.omniViewPropertyId === property.omniViewPropertyId)

            let newPropertyList = { ...propertyList }
            newPropertyList.compsList[rowIndex].sortBy = sortFieldName
            newPropertyList.compsList[rowIndex].sortOrder = order
            setPropertyList(newPropertyList)

        } catch (error) {
            console.log(' error in updateSortPreference :: ', error)
        }

    }


    const tableSort = sortField => {
        let order = 'asc'

        if (sort.field === sortField.fieldName) {
            order = sort.order === 'desc' ? 'asc' : 'desc'
        }

        setSort({ field: sortField.fieldName, order })

        const newUnitMixData = sortFieldsByName(unitMixData, sortField.fieldName, order)
        setUnitMixData(newUnitMixData)
    }

    const getSortIcon = sortField => {

        return (
            <>
                {sort && sort.field === sortField.fieldName ?
                    <span className='ml-2'><i className={`fa fa-sort-${sort.order}`}></i></span>
                    : null}
            </>
        )
    }

    return (
        <>
            {unitMixData.length ?
                <TableContainer component={Paper}>
                    <Table className={`${classes.table}`} size="" aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                {columns.map((col) => (
                                    <TableCell data-testid={`TableCell ${col.label} ${col.fieldName}`} className={`text-1 px-3 cursor-pointer break-words ${classes.tableCell}`} align={col.alignment} onClick={() => { if (col.sortable) { tableSort(col) } }}>{col.label}{col.sortable ? getSortIcon(col) : ''}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {unitMixData.map((row) => (
                                <TableRow >
                                    {columns.map((col) => (
                                        <TableCell className={`text-1 px-3 break-words ${classes.tableCell}`} align={col.alignment}>{getFieldValue(row, col)}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                            {/* <TableRow>
                                {columns.map((col) => (
                                    <TableCell className="text-1 px-3 break-words " align="right">{col.sumLabel}</TableCell>
                                ))}
                            </TableRow>
                            <TableRow className="bg-gray-5">
                                {columns.map((col) => (
                                    <TableCell className="text-1 px-3 break-words " align="right">{getSummaryValue(col)}</TableCell>
                                ))}
                            </TableRow> */}
                            <TableRow className="bg-gray-5">
                                {columns.map((col) => (
                                    <TableCell className="text-1 px-3 break-words " align={col.alignment}>
                                        <div className="flex flex-col">
                                            <span>{getSummaryValue(col)}</span>
                                            <span className="text-muted">{col.sumLabel}</span>
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                            {/* <TableRow>
                        <TableCell rowSpan={3} />
                        <TableCell colSpan={2}>Subtotal</TableCell>
                        <TableCell align="right">{ccyFormat(invoiceSubtotal)}</TableCell>
                    </TableRow> */}
                        </TableBody>
                    </Table>
                </TableContainer>
                : null
            }

        </>
    )
}

export default UnitMixTable

UnitMixTable.propTypes = {
    data: PropTypes.any,
    columns: PropTypes.any,
    property: PropTypes.any
}
